import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, Pipe } from '@angular/core';
import {
  faAngleLeft,
  faAngleRight,
  faChevronLeft,
  faChevronRight,
  faFileExport,
  faInfoCircle,
  faProjectDiagram,
  faStepBackward,
  faStepForward,
  faUser,
} from '@fortawesome/free-solid-svg-icons';

declare var $: any;
import { JiraUserService } from '../shared/services/jira-user.service';

@Component({
  selector: 'app-jira-user-stories',
  templateUrl: './jira-user-stories.component.html',
  styleUrls: ['./jira-user-stories.component.scss']
})
export class JiraUserStoriesComponent implements OnInit {


  constructor(private jiraServices: JiraUserService,
    public translate: TranslateService) {
  }
  faChevronLeft = faChevronLeft;
  faChevronRight = faChevronRight;
  faStepForward = faStepForward;
  faAngleRight = faAngleRight;
  faAngleLeft = faAngleLeft;
  faStepBackward = faStepBackward;
  faFileExport = faFileExport;
  faProjectDiagram = faProjectDiagram;
  faUser = faUser;
  faInfoCircle = faInfoCircle;
  
  jiraProjectList: any = [];
  jiraStoriesList:any = [];

  ngOnInit(): void {
    // this.getProjectList();
    // this.getProjectTasksList();
  }

  getProjectList() {
    let authorizationData = 'Basic ' + btoa('sreesailam.avinash489@gmail.com' + ':' + 'M3rOpjkP29RxanDi6Y0QFF3F')
    this.jiraServices.getAllJiraProjects(authorizationData).subscribe((response: any) => {
      // console.log("getAllJiraProjects", response);
      this.jiraProjectList = response;
    });
  }

  getProjectTasksList() {
    let authorizationData = 'Basic ' + btoa('sreesailam.avinash489@gmail.com' + ':' + 'M3rOpjkP29RxanDi6Y0QFF3F')
    this.jiraServices.getAllJiraStories(authorizationData,'',1).subscribe((response: any) => {
      // console.log('getUserStories res', response);
      // console.log("getAllJiraStories", response);
      this.jiraStoriesList = response.issues;
    });
  }

}
